'use client';

import { useContext } from 'react';

import { ShowHideRootContext } from './context/show-hide-root.context';
import type { ShowHideHiddenPropsInterface } from './types/show-hide-hidden.types';

/**
 * @since 8.36.0
 */
export const ShowHideHidden = (props: ShowHideHiddenPropsInterface) => {
  const { children } = props;
  const { isHidden } = useContext(ShowHideRootContext);

  return <>{isHidden ? null : children}</>;
};

ShowHideHidden.displayName = 'ShowHide.Hidden';
